export const limitImageSelection = <T>(
	fileList: T[],
	existingImageCount: number,
	maxImages: number,
) => {
	const capacity = Math.max(0, maxImages - existingImageCount);

	return {
		fileList: fileList.slice(0, capacity),
		rejectedCount: Math.max(0, fileList.length - capacity),
	};
};
